import { useLocale } from "../../../hooks/useLocale";
import { msg } from "../../../locales/translate";
import { VBox } from "@ui/box/Box";
import Panel from "@ui/panel/Panel";
import { useState } from "react";
import { GD } from "src/GD";
import { FormParser } from "../../FormParser";
import Signal from "badmfck-signal";
import { S_CONFIRM } from "src/view/popup/general/ConfirmDialog";

interface IChangeSessionStatusData {
	sessionId: number;
	currentStatus: string;
}

export const S_CHANGE_SESSION_STATUS_POPUP = new Signal<IChangeSessionStatusData | null>("S_CHANGE_SESSION_STATUS_POPUP");

interface ISessionStatusModel {
	session_status: {
		status: string;
		reason: string;
	} & Record<string, any>;
}

const SESSION_STATUSES = ["created", "failed", "pending", "completed", "expired", "canceled"];

const getChangeStatusModel = (currentStatus: string): ISessionStatusModel & Record<string, any> => {
	return {
		session_status: {
			status: currentStatus,
			$__status_type: "select",
			$__status_values: SESSION_STATUSES,
			reason: "",
			$__reason_type: "textarea",
			$__reason_linked: "status",
			$__reason_linked_value: "failed",
		},
	};
};

export const ChangeSessionStatusPopup = () => {
	useLocale();
	const data = S_CHANGE_SESSION_STATUS_POPUP.use();
	const [busy, setBusy] = useState(false);

	if (!data) return null;

	const closePopup = () => {
		setBusy(false);
		S_CHANGE_SESSION_STATUS_POPUP.invoke(null);
	};

	return (
		<Panel
			sx={{ maxWidth: "520px", minWidth: "360px", width: "95vw" }}
			scrollable
			growContent
			decorator="absolute"
			onClose={closePopup}
			label={msg("changeSessionStatus")}
			busy={busy}>
			<VBox gap="10px">
				<FormParser<ISessionStatusModel>
					secondaryButton={null}
					key={"session-status-" + data.sessionId}
					primaryButton={{
						title: msg("changeStatus"),
					}}
					onSubmit={async (formData: ISessionStatusModel): Promise<any> => {
						return new Promise(resolve => {
							S_CONFIRM.invoke({
								title: msg("pleaseNote"),
								message: msg("youAreUsingRealMoneyAndYourActionsWillBeRecorded"),
								confirm: msg("changeStatus"),
								reject: "Cancel",
								onResult: async val => {
									if (val === "confirm") {
										setBusy(true);
										const requestData: { session_id: number; status: string; reason?: string } = {
											session_id: data.sessionId,
											status: formData.session_status.status,
										};

										if (formData.session_status.status === "failed") requestData.reason = formData.session_status.reason;

										const response = await GD.REQ_API.request({
											method: "gate/status/change",
											data: requestData,
										});
										if (response.error) {
											setBusy(false);
											resolve(response);
											return response;
										}
										setBusy(false);
										closePopup();
										resolve(formData);
									}
								},
							});
						});
					}}
					onRequest={async (): Promise<ISessionStatusModel> => {
						return getChangeStatusModel(data.currentStatus);
					}}
				/>
			</VBox>
		</Panel>
	);
};
